import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const IS_BROWSER_TOKEN = new InjectionToken<boolean>('IS_BROWSER_TOKEN', {
  providedIn: 'root',
  factory: () => {
    return isPlatformBrowser(inject(PLATFORM_ID));
  }
});
